/* eslint-disable quotes */
import type { TypeLang, TypeJsonLdSearchData } from '@/schema'
import { buildUrl, getIetfLang } from './_url'

const NAMES: Record<TypeLang, string> = {
  es: 'Resultados de búsqueda',
  en: 'Search Results'
}

export function jsonLdSearchPage(data: TypeJsonLdSearchData | null, locale: TypeLang) {
  const url = buildUrl(locale, '/search')

  const schema = {
    "@context": "https://schema.org",
    "@type": "SearchResultsPage",
    "url": data?.query ? `${url}?q=${encodeURIComponent(data.query)}` : url,
    "name": NAMES[locale],
    "inLanguage": getIetfLang(locale),
    "isPartOf": {
      "@id": `${buildUrl(locale)}/#website`
    }
  }

  return JSON.stringify(schema)
}
